// extracted by mini-css-extract-plugin
export default {"item":"BrandItem_item__Hdb6a"};